module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-235.2cd79056.svg";